var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "21", height: "21", viewBox: "0 0 21 21", fill: "none" }, props),
    React.createElement("path", { d: "M10.5 6.5L6.5 10.5M10.5 6.5V14.5M10.5 6.5L14.5 10.5M19.5 10.5C19.5 15.4706 15.4706 19.5 10.5 19.5C5.52944 19.5 1.5 15.4706 1.5 10.5C1.5 5.52944 5.52944 1.5 10.5 1.5C15.4706 1.5 19.5 5.52944 19.5 10.5Z", stroke: "#fff", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
  );
});